import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
// 导入 Element UI 样式
import 'element-ui/lib/theme-chalk/index.css'

// 全局注册 Element UI
Vue.use(ElementUI)

Vue.config.productionTip = false
console.log = function() {}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
